export default "__VITE_ASSET__BUc5BIEs__"